import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";

const ShopifyTutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Shopify tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn how to build Shopify apps using the built-in Shopify plugin, which handles webhook subscriptions, data sync, authentication,
          AppBridge set up, session token management (and more!) out of the box.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Build a full stack Shopify app"
            color={colors.white}
            body="Build an admin-embedded Shopify app that automatically tags products in a store based on description keywords."
            href="/guides/tutorials/automated-product-tagger"
            copy="Build your first Shopify app with Gadget →"
          />
          <SplashCard
            title="Forward data to an external service"
            color={colors.white}
            body="Use Gadget's background actions to reliably send Shopify data to an existing service."
            href="/guides/tutorials/middleware"
            copy="Start building →"
          />
          <SplashCard
            title="Building with Shopify UI extensions"
            color={colors.white}
            body="Learn how to call your Gadget API from a Shopify UI extension."
            href="/guides/tutorials/shopify/ui-extension"
            copy="Start building →"
          />
          <SplashCard
            title="Building with Shopify theme app extensions"
            color={colors.white}
            body="Learn how to call a Gadget API from a Shopify storefront, using a Shopify app proxy."
            href="/guides/tutorials/shopify/theme-app-extensions"
            copy="Start building →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default ShopifyTutorialsLandingPage;
